import { IconWrapper } from '../runtime';
export default IconWrapper('disconnect', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M3 2.99969L13 12.9997",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.59517 7.83832L2.44531 8.98817C1.1849 10.2486 1.1849 12.2921 2.44531 13.5525C3.70572 14.8129 5.74925 14.8129 7.00966 13.5525L8.15952 12.4027M7.83781 3.59568L8.99034 2.44314C10.2508 1.18273 12.2943 1.18273 13.5547 2.44314C14.8151 3.70355 14.8151 5.74708 13.5547 7.00749L12.4022 8.16003",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});